// Small SEO helpers shared by public pages (slug matching + image alt text).

export const slugify = (text, fallback = "") => {
  if (!text) return fallback;
  const s = String(text)
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-{2,}/g, "-")
    .replace(/^-|-$/g, "");
  return s || fallback;
};

export const extractCity = (address, fallback = "Ahmedabad") => {
  if (!address) return fallback;
  const parts = String(address)
    .split(",")
    .map((p) => p.trim())
    .filter(Boolean);
  if (!parts.length) return fallback;
  const last = parts[parts.length - 1].replace(/\b\d{5,6}\b/g, "").replace(/[-\s]+$/, "").trim();
  return last || fallback;
};

// Standard product image alt text used across the site.
export const productAlt = (productName, shopName, address) => {
  const city = extractCity(address);
  const at = shopName ? ` at ${shopName}` : "";
  return `${(productName || "Product").trim()}${at}, ${city} - MapBazzar`;
};
